import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export const Dialog = (theme: Theme) => {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          //filter: "blur(8px)"
        },
      },
    },
  };
};
